import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import {
  CountrysideZoneCreationPayload,
  CreatedCountrysideZoneData,
} from './countryside-zone-creation.types';

export async function createCountrysideZoneService({ body }: CountrysideZoneCreationPayload) {
  const { response, data } = await BACKEND.post<CreatedCountrysideZoneData>(ENDPOINT.COUNTRYSIDES_ZONES, {
    body,
  });

  return {
    response,
    summary: data,
  };
}
